import { styled } from 'styled-components';
import { IStateAnswerWithImage } from '~/data/types';

type IProps = {
  stateAnswers: IStateAnswerWithImage[];
  lastQuestion?: boolean;
};

type TProps = IProps;

export function StateAnswers({ stateAnswers, lastQuestion }: TProps) {
  return (
    <Container>
      {stateAnswers &&
        !lastQuestion &&
        stateAnswers.map((icon, index) => (
          <SStateItem key={index}>
            <img src={icon.image} alt="" />
          </SStateItem>
        ))}
      {stateAnswers.length > 0 && lastQuestion && (
        <SStateItem>
          <img src={stateAnswers[0].image} alt="" />
        </SStateItem>
      )}
    </Container>
  );
}

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 10px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  user-select: none;
  z-index: 1000;

  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
`;

const SStateItem = styled.div`
  height: 50px;
  width: 50px;
  position: relative;
  margin: 2px;
  z-index: 10;

  @media screen and (max-width: 450px) {
    height: 35px;
    width: 35px;
  }
  @media screen and (max-height: 450px) {
    height: 35px;
    width: 35px;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
`;
